import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import './DatasetsList.css';
import { Table, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import moment from 'moment';
import { Divider } from 'antd';
import { Icon } from '@ohif/ui/src/elements/Icon';
import { SimpleDialog } from '@ohif/ui/src/components/simpleDialog';
import { servicesManager } from '../../App.js';
import { Tooltip } from '@ohif/ui/src/components/tooltip';
import { OverlayTrigger } from '@ohif/ui/src/components/overlayTrigger';
import {
  getImageDataList,
  editImageData,
  checkAccess,
  exportImageData,
  getSelectOption,
} from './api';
import StatusCell from './status.js';
import StepsCell from './steps.js';
import useSearchParams from '@ohif/viewer/src/customHooks/useSearchParams';

let originalData = [];
let isLock = false;
let searchInput; //....
const columns = [
  {
    title: '名称',
    width: 200,
    dataIndex: 'name',
    key: 'name',
    render(text) {
      if (text && text.length > 15) {
        return (
          <>
            <OverlayTrigger
              key={1}
              placement="top"
              overlay={
                <Tooltip
                  placement="top"
                  className="in tooltip-warning"
                  id="tooltip-top"
                >
                  <div className="warningContent">{text}</div>
                </Tooltip>
              }
            >
              <div>{text.substring(0, 12) + '...'}</div>
            </OverlayTrigger>
          </>
        );
      } else {
        return text;
      }
    },
  },
  {
    title: '类别',
    width: 100,
    dataIndex: 'typeName',
    key: 'typeName',
    filterMode: 'tree',
    filters: [],
    // defaultFilteredValue: [496, 497],
  },
  {
    title: '当前步骤',
    width: 150,
    dataIndex: 'stepName',
    key: 'stepName',
  },
  {
    title: '状态',
    width: 150,
    dataIndex: 'statusName',
    key: 'statusName',
  },
  {
    title: '当前数量',
    width: 100,
    dataIndex: 'capacity',
  },
  {
    title: '责任人',
    width: 120,
    dataIndex: 'responsibleName',
  },
  {
    title: '最后更新时间',
    width: 200,
    dataIndex: 'createAt',
    render: text => (text ? moment(text).format('YYYY/MM/DD HH:mm:ss') : ''),
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'operate',
  },
  {
    title: '部位',
    width: 150,
    dataIndex: 'organName',
  },
  {
    title: '设备',
    width: 100,
    dataIndex: 'deviceName',
  },
  {
    title: '锁定',
    width: 80,
    dataIndex: 'lock',
  },
];

function DatasetsList({ getRowValue, isRefresh, isClearn }) {
  const history = useHistory();

  const stateChangeState = useCallback(
    value => {
      if (isLock) {
        //有数据锁定
        if (value.lock) {
          //解除原锁定数据
          isLock = false;
          value.lock = false;
          setSelectRow(null);
          let arr = originalData.map(i => {
            i.opt = 1;
            i.lock = false;
            return i;
          });
          // getRowValue({ original: e.original });
          setData(arr);
          localStorage.setItem('lock', '');
        } else {
          //切换锁定数据
          value.lock = true;
          setSelectRow(value);
          let arr = originalData.map(i => {
            i.lock = false;
            i.opt = 1;
            if (i.id === value.id) {
              i.lock = true;
            }
            return i;
          });
          setData(arr);
          setCurrentRowId(value.id);
          localStorage.setItem('lock', value.id);
          getRowValue({ original: value });
        }
      } else {
        if (value.id == currentRowId) {
          value.lock = true;
          setSelectRow(value);
          let arr = originalData.map(i => {
            i.lock = false;
            i.opt = 1;
            if (i.id === value.id) {
              i.lock = true;
            }
            return i;
          });
          setData(arr);
          isLock = true;
          localStorage.setItem('lock', value.id);
          getRowValue({ original: value });
        } else {
          value.lock = true;
          setSelectRow(value);
          let arr = originalData.map(i => {
            i.lock = false;
            i.opt = 1;
            if (i.id === value.id) {
              i.lock = true;
            }
            return i;
          });
          setData(arr);
          isLock = true;
          getRowValue({ original: value });
          setCurrentRowId(value.id);
          localStorage.setItem('lock', value.id);
        }
      }
    },
    [currentRowId, getRowValue]
  );

  const edit = useCallback(
    async e => {
      let res = await checkAccess({ id: e.id });
      if (!res.data) {
        const { UINotificationService } = servicesManager.services;
        const message = '无法进行该操作，请联系项目发起人';
        UINotificationService.show({
          title: '提示',
          message,
          type: 'warning',
          autoClose: true,
        });
        return;
      }
      if (isLock) {
        if (e.lock) {
          e.opt = 3;
          setCurrentRowId(e.id);
          getRowValue({ original: e });
        } else {
          setNewSelectRow(e);
          setIsEditDialogOpen(true);
        }
      } else {
        e.opt = 3;
        setSelectRow(e);
        setCurrentRowId(e.id);
        getRowValue({ original: e });
      }
    },
    [getRowValue]
  );

  const del = async e => {
    if (isLock) {
      if (e.lock) {
        setNewSelectRow(e);
        setIsDelDialogOpen(true);
      } else {
        setIsDialogOpen(true);
        setSelectRow(e);
      }
    } else {
      setIsDialogOpen(true);
      setSelectRow(e);
    }
  };

  //启停用
  const enable = useCallback(
    (e, t) => {
      let payload = { id: e.id, p1: t };
      const message = '';
      const { UINotificationService } = servicesManager.services;
      editImageData(payload).then(res => {
        if (res.status == 'success') {
          UINotificationService.show({
            title: '修改成功',
            message,
            type: 'info',
            autoClose: true,
          });
          if (t == '1' && e.lock) {
            localStorage.setItem('lock', '');
            isLock = false;
          }
          handleQueryList();
          let arr = data.filter(i => i.id == currentRowId);
          if (arr.length > 0) {
            arr[0].p1 = t;
            getRowValue({ original: arr[0] });
          }
        }
      });
    },
    [currentRowId, data, getRowValue, handleQueryList]
  );
  //封装 导出
  const packageData = e => {
    let payload = { imageDataScienceId: e.id };
    const message = '';
    const { UINotificationService } = servicesManager.services;
    exportImageData(payload).then(res => {
      if (res.status == 'success') {
        UINotificationService.show({
          title: '修改成功',
          message,
          type: 'info',
          autoClose: true,
        });
        // if (t == '1' && e.lock) {
        //   localStorage.setItem('lock', '');
        //   isLock = false;
        // }
        // handleQueryList();
        // let arr = data.filter(i => i.id == currentRowId);
        // if (arr.length > 0) {
        //   arr[0].p1 = t;
        //   getRowValue({ original: arr[0] });
        // }
      }
    });
  };

  const onClose = () => {
    setIsDialogOpen(false);
  };
  const onEditClose = () => {
    setIsEditDialogOpen(false);
  };
  const onDelClose = () => {
    setIsDelDialogOpen(false);
  };
  const onConfirm = async () => {
    setIsDialogOpen(false);
    let payload = { id: selectRow.id, p1: '2' };
    const message = '';
    const { UINotificationService } = servicesManager.services;
    editImageData(payload).then(res => {
      if (res.status == 'success') {
        UINotificationService.show({
          title: '删除成功',
          message,
          type: 'info',
          autoClose: true,
        });
        // if(selectRow.lock){
        //   localStorage.setItem('lock', '');
        //   isLock = false;
        // }
        handleQueryList();
      }
    });

    history.push({
      pathname: '/research',
    });
  };

  const onDelConfirm = async () => {
    setIsDelDialogOpen(false);
    let payload = { id: newSelectRow.id, p1: '2' };
    const message = '';
    const { UINotificationService } = servicesManager.services;
    editImageData(payload).then(res => {
      if (res.status == 'success') {
        UINotificationService.show({
          title: '删除成功',
          message,
          type: 'info',
          autoClose: true,
        });
        localStorage.setItem('lock', '');
        handleQueryList();
      }
    });
    // history.push({
    //   pathname: '/research',
    // });
  };

  const onEditConfirm = t => {
    setIsEditDialogOpen(false);
    let arr = originalData.map(i => {
      i.lock = false;
      i.opt = 1;
      if (i.id === newSelectRow.id) {
        i.lock = true;
      }
      return i;
    });
    setData(arr);
    newSelectRow.lock = true;
    newSelectRow.opt = 3;
    setCurrentRowId(newSelectRow.id);
    getRowValue({ original: newSelectRow });
    localStorage.setItem('lock', newSelectRow.id);
  };

  const [data, setData] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDelDialogOpen, setIsDelDialogOpen] = useState(false);
  const [selectRow, setSelectRow] = useState();
  const [newSelectRow, setNewSelectRow] = useState();

  const [filterOption, setFilterOption] = useState([]);
  const [filterValues, setFilterValues] = useState({
    name: '', //名称
    responsibleName: '', //责任人
    typeName: [], //类别 默认选中团队和个人
  });

  useEffect(() => {
    getSelectOption({ code: 'IMAGEDATATYPE' }).then(res => {
      if (res.list && res.list.length) {
        setFilterOption(toFilterArr(res.list));
        let arr = res.list.map(i => {
          if (['团队', '个人'].includes(i.name)) {
            return i.id;
          }
        });
        setFilterValues(state => ({
          ...state,
          typeName: arr,
        }));
      }
    });
  }, []);

  //定义表头2
  const getColumnSearchProps = useCallback(
    dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              searchInput = node;
            }}
            placeholder={`请输入`}
            value={selectedKeys[0]}
            onChange={e => {
              console.log(selectedKeys);
              setSelectedKeys(e.target.value ? [e.target.value] : []);
            }}
            onPressEnter={() => {
              confirm();
            }}
          />
        </div>
      ),
      filterIcon: filtered => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => searchInput.select(), 100);
        }
      },
    }),
    []
  );

  // 定义表列数据
  const formatColumns = useMemo(() => {
    columns[0] = { ...columns[0], ...getColumnSearchProps('name') };
    columns[0].filteredValue = filterValues.name || null;
    columns[1].filters = filterOption;
    columns[1].filteredValue = filterValues.typeName || null;
    columns[2].render = (_, record) => {
      if (record.p1 == '1' || !record.myself || isLock) {
        if (record.lock) {
          return (
            <>
              <StepsCell item={record} onChange={e => handleQueryList()} />
            </>
          );
        } else {
          return <>{record.stepName}</>;
        }
      } else {
        return (
          <>
            <StepsCell item={record} onChange={e => handleQueryList()} />
          </>
        );
      }
    };
    columns[3].render = (_, record) => {
      if (record.p1 == '1' || !record.myself || isLock) {
        if (record.lock) {
          return (
            <>
              <StatusCell item={record} onChange={e => handleQueryList()} />
            </>
          );
        } else {
          return <>{record.statusName}</>;
        }
      } else {
        return (
          <>
            <StatusCell item={record} onChange={e => handleQueryList()} />
          </>
        );
      }
    };
    columns[5] = {
      ...columns[5],
      ...getColumnSearchProps('responsibleName'),
    };
    columns[5].filteredValue = filterValues.responsibleName || null;
    columns[7].render = (_, record) => {
      if (record.myself) {
        return (
          <>
            <div>
              <a
                onClick={e => {
                  del(record);
                  e.stopPropagation();
                }}
              >
                删除
              </a>
              <Divider
                type="vertical"
                style={{ borderLeft: '1px solid #D8D8D8' }}
              />
              {record.p1 == '0' && (
                <>
                  <a
                    onClick={e => {
                      edit(record);
                      e.stopPropagation();
                    }}
                  >
                    编辑
                  </a>
                  <Divider
                    type="vertical"
                    style={{ borderLeft: '1px solid #D8D8D8' }}
                  />
                  <a
                    onClick={e => {
                      enable(record, '1');
                      e.stopPropagation();
                    }}
                  >
                    停用
                  </a>
                </>
              )}
              {record.p1 == '1' && (
                <>
                  <a style={{ color: '#838485' }}>编辑</a>
                  <Divider
                    type="vertical"
                    style={{ borderLeft: '1px solid #D8D8D8' }}
                  />
                  <a
                    onClick={e => {
                      enable(record, '0');
                      e.stopPropagation();
                    }}
                  >
                    启用
                  </a>
                </>
              )}
              <Divider
                type="vertical"
                style={{ borderLeft: '1px solid #D8D8D8' }}
              />
              <a
                onClick={e => {
                  packageData(record);
                  e.stopPropagation();
                }}
              >
                封装
              </a>
            </div>
          </>
        );
      } else {
        return (
          <>
            <div>
              <a style={{ color: '#838485' }}>删除</a>
              <Divider
                type="vertical"
                style={{ borderLeft: '1px solid #D8D8D8' }}
              />
              <a style={{ color: '#838485' }}>编辑</a>
              <Divider
                type="vertical"
                style={{ borderLeft: '1px solid #D8D8D8' }}
              />
              <a style={{ color: '#838485' }}>
                {record.p1 == '0' ? '停用' : '启用'}
              </a>
              <Divider
                type="vertical"
                style={{ borderLeft: '1px solid #D8D8D8' }}
              />
              <a style={{ color: '#838485' }}>封装</a>
            </div>
          </>
        );
      }
    };
    columns[10].render = (_, record) => {
      if (record.p1 == '1') {
        return (
          <>
            <Icon name="locking" />
          </>
        );
      } else {
        return (
          <>
            <div
              onClick={e => {
                stateChangeState(record);
                e.stopPropagation();
              }}
            >
              {!record.lock && <Icon name="locking" />}
              {record.lock && <Icon color="red" name="locking" />}
            </div>
          </>
        );
      }
    };
    const data = columns.map(item => item);
    return data;
  }, [
    edit,
    enable,
    filterOption,
    filterValues,
    getColumnSearchProps,
    handleQueryList,
    stateChangeState,
  ]);

  const [currentRowId, setCurrentRowId] = useState('');
  const genSetCurrentRowId = useCallback(
    id => {
      if (!isLock) {
        id = Number(id);
        const record = data.find(item => item.id === id);
        if (!record) return;
        setCurrentRowId(record.id);
        record.opt = 1;
        getRowValue({ original: record });
      }
    },
    [data, getRowValue]
  );

  const [pagination, setPagination] = useState({ current: 1, pageSize: 5 });
  const { current, pageSize } = pagination;
  //转换数据
  const toFilterArr = data => {
    if (!data) return [];
    if (data.length) {
      return data.map(i => {
        return {
          text: i.name,
          value: i.id,
        };
      });
    }
    return [];
  };

  // 新
  const [loading, setLoading] = useState(false);
  const handleQueryList = useCallback(() => {
    setLoading(true);
    getImageDataList({
      pageNum: current,
      pageSize: pageSize,
      name: filterValues.name, //名称
      responsibleName: filterValues.responsibleName, //责任人
      typeName: filterValues.typeName, //类别
    })
      .then(res => {
        let list = res.data.records.map(i => {
          i.lock = false;
          i.opt = 1;
          i.dicCheckId = parseInt(i.dicCheckId);
          if (!localStorage.getItem('lock')) isLock = false;
          if (i.id == localStorage.getItem('lock')) {
            i.lock = true;
            isLock = true;
            setSelectRow(i);
            setCurrentRowId(i.id);
          }
          return i;
        });
        setData(list);
        setPagination(state => ({ ...state, total: res.data.total }));
        let arr = res.data.records.filter(i => i.lock);
        if (arr.length > 0) {
          getRowValue({ original: arr[0] });
        }
        originalData = list;
      })
      .finally(() => setLoading(false));
  }, [current, pageSize, filterValues, getRowValue]);
  useEffect(handleQueryList, [handleQueryList, isRefresh]);
  // useEffect(getOption, [getOption]);

  useEffect(() => {
    setCurrentRowId(null);
  }, [isClearn]);

  const [searchParams, joinSearch] = useSearchParams();
  const searchParamsRef = useRef(searchParams);
  searchParamsRef.current = searchParams;
  const genSetPagination = useCallback((current, pageSize) => {
    setPagination(state => ({
      ...state,
      current: Number(current) || state.current,
      pageSize: Number(pageSize) || state.pageSize,
    }));
  }, []);
  // 映射分页到URL
  useEffect(() => {
    history.replace({
      search: joinSearch({
        ...searchParamsRef.current,
        page: pagination.current,
        pageSize: pagination.pageSize,
      }),
    });
  }, [history, joinSearch, pagination]);
  // 初始化分页与选中数据
  useEffect(() => {
    if (loading) return;
    const { pro, page, pageSize } = searchParamsRef.current;
    if (pro) genSetCurrentRowId(pro);
    genSetPagination(page, pageSize);
  }, [genSetCurrentRowId, genSetPagination, loading]);

  // 判断两个对象是否相同
  const isObjectValueEqual = (obj1, obj2) => {
    var aProps = Object.getOwnPropertyNames(obj1);
    var bProps = Object.getOwnPropertyNames(obj2);
    if (aProps.length != bProps.length) {
      return false;
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      var propA = obj1[propName];
      var propB = obj2[propName];
      if (typeof propA === 'object') {
        if (isObjectValueEqual(propA, propB)) {
          // return true     这里不能return ,后面的对象还没判断
        } else {
          return false;
        }
      } else if (propA !== propB) {
        return false;
      }
    }
    return true;
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    // console.log('params', pagination, filters, sorter, extra);
    if (extra.action === 'filter') {
      let obj = {
        name: filters.name ? filters.name : '', //名称
        responsibleName: filters.responsibleName ? filters.responsibleName : '', //责任人
        typeName: filters.typeName ? filters.typeName : [], //类别
      };
      if (!isObjectValueEqual(filterValues, obj)) {
        setFilterValues(obj);
        setCurrentRowId(null);
        getRowValue({ original: { id: null } });
      }
    }
  };

  return (
    <>
      <div>
        <Table
          onRow={record => {
            return {
              onClick: () => genSetCurrentRowId(record.id),
            };
          }}
          rowKey="id"
          rowClassName={(record, index) => {
            if (record.id == currentRowId) {
              return 'datasets active';
            } else {
              if (record.p1 == '1') {
                return 'datasets locked';
              } else {
                return 'datasets';
              }
            }
          }}
          columns={formatColumns}
          dataSource={data}
          loading={loading}
          pagination={{
            size: 'small',
            ...pagination,
            onChange: genSetPagination,
          }}
          scroll={{ y: 240 }}
          onChange={tableOnChange}
        />
      </div>
      <SimpleDialog
        rootClass="datasetsListDialog"
        isOpen={isDialogOpen}
        headerTitle="提示信息"
        onClose={onClose}
        onConfirm={onConfirm}
      >
        <label className="simpleDialogLabelFor">
          是否删除{selectRow ? selectRow.name : ''}？
        </label>
      </SimpleDialog>
      <SimpleDialog
        rootClass="datasetsListDialog"
        isOpen={isEditDialogOpen}
        headerTitle="提示信息"
        onClose={onEditClose}
        onConfirm={onEditConfirm}
      >
        <label className="simpleDialogLabelFor">
          您已锁定{selectRow ? selectRow.name : ''}，是否切换到
          {newSelectRow ? newSelectRow.name : ''}？
        </label>
      </SimpleDialog>
      <SimpleDialog
        rootClass="datasetsListDialog"
        isOpen={isDelDialogOpen}
        headerTitle="提示信息"
        onClose={onDelClose}
        onConfirm={onDelConfirm}
      >
        <label className="simpleDialogLabelFor">
          当前数据已锁定，是否删除？
        </label>
      </SimpleDialog>
    </>
  );
}
DatasetsList.propTypes = {
  getRowValue: PropTypes.func,
  getRowProps: PropTypes.func,
  isRefresh: PropTypes.bool,
  isClearn: PropTypes.bool,
};

DatasetsList.defaultProps = {
  isRefresh: false,
  isClearn: false,
};

export default DatasetsList;
